import { LayoutList } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useRightPanel } from '@/components/layout/workspace/rightPanelContext';
import { Button } from '@/components/ui';
import { OWNERS, panelOf } from './model';
import { useRecords } from './recordsContext';
import { RecordDetails } from './RecordDetails';

export function RecordPage() {
  const { id } = useParams();
  const panel = useRightPanel();
  const { records } = useRecords();
  const record = records.find((r) => r.id === id);
  if (!record)
    return (
      <main className="p-6">
        <h2 data-panel-default-focus="" tabIndex={-1} className="type-title">
          Запись не найдена
        </h2>
        <p className="mt-3 text-sm text-fg-muted">Выбери другую запись в списке.</p>
      </main>
    );
  return (
    <main className="flex flex-col gap-6 p-6">
      <header>
        <p className="mb-2 type-overline text-fg-subtle">Запись № {record.id}</p>
        <h2 data-panel-default-focus="" tabIndex={-1} className="type-title focus-visible:outline-none">
          {record.title}
        </h2>
      </header>
      <div>
        <Button
          variant="secondary"
          data-panel-trigger={record.id}
          onClick={(e) => panel.open(panelOf(record), e.currentTarget)}
        >
          <LayoutList className="size-4" />
          Свойства записи
        </Button>
      </div>
      <div className="max-w-2xl rounded-lg border border-line bg-card p-5">
        <RecordDetails item={panelOf(record)} />
      </div>
    </main>
  );
}

export function PersonPage() {
  const { id } = useParams();
  const owner = OWNERS[Number(id)] ?? 'Сотрудник не найден';
  return (
    <main className="p-6">
      <h2 data-panel-default-focus="" tabIndex={-1} className="type-title focus-visible:outline-none">
        {owner}
      </h2>
      <p className="mt-3 text-sm text-fg-muted">Связанный объект открывается своей вкладкой в том же окне.</p>
    </main>
  );
}
